<template>
  <div class="cal-day prev-month prev-day">
    <div class="day-number">{{ day.day }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DateTime } from 'luxon';

export default defineComponent({
  props: {
    day: { type: Object as () => DateTime, required: true }
  }
});

</script>
